import { render, staticRenderFns } from "./private-commercial-proposal-card.vue?vue&type=template&id=143ec5d6&scoped=true&"
import script from "./private-commercial-proposal-card.vue?vue&type=script&lang=js&"
export * from "./private-commercial-proposal-card.vue?vue&type=script&lang=js&"
import style0 from "./private-commercial-proposal-card.vue?vue&type=style&index=0&id=143ec5d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143ec5d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('143ec5d6')) {
      api.createRecord('143ec5d6', component.options)
    } else {
      api.reload('143ec5d6', component.options)
    }
    module.hot.accept("./private-commercial-proposal-card.vue?vue&type=template&id=143ec5d6&scoped=true&", function () {
      api.rerender('143ec5d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/commercial/partials/private-commercial-proposal-card.vue"
export default component.exports